import _fetch from 'isomorphic-fetch';
import { trackEvent } from '../tracking-tool/app-insights';

type BatchData = Record<string, any>;

/**
 * Batch of requests to be send
 */
const batch = [];

/**
 * Fetch Request init
 */
const requestInit: RequestInit = {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};

/**
 * Adds a request to a
 * @param {Record} request
 */
const addToBatch = (request: BatchData = {}) => {
    if (window.RELEASE.EVENT_HUB_TRACKER_SWITCHER) {
        batch.push(request);
        if (batch.length === 5) {
            sendBatchToEventHub(batch.splice(0, 5));
        }
    }
};

/**
 * Sends batch to event hub
 * @param {Array} batch Collection of requests
 */
const sendBatchToEventHub = (batch: BatchData[]) => {
    if (window.RELEASE.EVENT_HUB_API_URL) {
        _fetch(window.RELEASE.EVENT_HUB_API_URL, {
            ...requestInit,
            body: JSON.stringify(batch),
        }).catch((error) => trackEvent('EVENT_HUB_XHR_ERROR', error));
    }
};

export { addToBatch };
